import { gql } from "@apollo/client";

export const GET_EVOLUTION_DATA = gql`
  query Evolution(
    $siteId: SiteID!
    $devices: [String!]!
    $startDate: String!
    $endDate: String!
    $previousStartDate: String!
    $previousEndDate: String!
    $segment: String!
    $query: QueryByName!
  ) {
    currentPeriod: monitor(
      siteId: $siteId
      segment: $segment
      devices: $devices
      query: $query
      startDate: $startDate
      endDate: $endDate
    ) {
      headers
      rows {
        floatValue
        stringValue
      }
    }
    previousPeriod: monitor(
      siteId: $siteId
      segment: $segment
      devices: $devices
      query: $query
      startDate: $previousStartDate
      endDate: $previousEndDate
    ) {
      headers
      rows {
        floatValue
        stringValue
      }
    }
  }
`;
